import React from "react";

const tagShortcuts = [
  { label: "Contact", color: "#FFD476", windows: "Alt + O", mac: "⌘⌥ + O" },
  { label: "Client", color: "#D9ADE1", windows: "Alt + C", mac: "⌘⌥ + C" },
  { label: "Matter", color: "#90CBF9", windows: "Alt + M", mac: "⌘⌥ + M" }
];

export const SelectContactTooltipTemplate = () => (
  <div className="flex w-[200px] flex-col gap-1">
    <div className="text-xs font-bold leading-4 tracking-[0.5px] text-white">
      Insert a tag to search
    </div>

    <div className="box-border border-[#F5F5F5] border overflow-clip grid h-28 w-[200px] grid-cols-[71px_62px_63px] grid-rows-4 gap-px rounded-[4px] bg-black/25 p-px text-xs leading-4 tracking-[0.5px] text-[#333]">
      <div className="flex min-h-0 min-w-0 items-center justify-center rounded-tl-[3px] bg-[#F5F5F5]" />
      <div className="flex min-h-0 min-w-0 items-center justify-center bg-[#F5F5F5]">Windows</div>
      <div className="flex min-h-0 min-w-0 items-center justify-center rounded-tr-[3px] bg-[#F5F5F5]">Mac</div>

      {tagShortcuts.map(({ label, color, windows, mac }, index) => (
        <React.Fragment key={label}>
          <div className={`flex min-h-0 min-w-0 items-center justify-center bg-[#F5F5F5] ${index === tagShortcuts.length - 1 ? "rounded-bl-[3px]" : ""}`}>
            <span
              className="box-border whitespace-nowrap px-1 pb-px leading-3"
              style={{ border: "none", borderBottom: `2px solid ${color}` }}
            >
              {label}
            </span>
          </div>
          <div className="flex min-h-0 min-w-0 items-center justify-center bg-white">
            {windows}
          </div>
          <div className={`flex min-h-0 min-w-0 items-center justify-center bg-white ${index === tagShortcuts.length - 1 ? "rounded-br-[3px]" : ""}`}>
            {mac}
          </div>
        </React.Fragment>
      ))}
    </div>

    <div className="text-xs font-normal leading-4 tracking-[0.5px] text-white">
      We recommend filling in matter and client on the time entry first to auto-populate tags.
    </div>
  </div>
);

